module.exports = __webpack_public_path__ + "img/la.999c6e60.svg";